// partly duplicated by seatPlanCtrl.js which will go away with the options v1 page

module TR {

    export interface FlightSeatPlan {
        Passengers: SeatPlanPassenger[];
        Restrictions?: {
            AllSegments: boolean;
            FullSegments: boolean;
        }[];
        Segments: {
            Inbound: SeatPlanSegment[];
            Outbound: SeatPlanSegment[];
        };
    }

    export interface SeatPlanPassenger {
        Description?: string;
        HasInfant: boolean;
        IsChild: boolean;
        Seats: {
            Number: string | null;
            Price: number;
            Segement: number; // intentionally misspelt
        }[];
    }

    export interface SeatPlanSegment {
        SeatPlan: {
            HeaderRow: Row;
            Rows: Row[];
            SeatMessages?: {
                Id: number;
                Information: string;
                SupplierId: number;
            }[];
        };
        DepartureAirportCode: string;
        DepartureDate: string;
        DestinationAirportCode: string;
    }

    interface Row {
        Blocks: {
            Seats: {
                AdditionalInfoTextId: number;
                AdultPrice: number;
                AdultWithInfantPrice: number;
                AvailableForChild: boolean
                AvailableForInfant: boolean;
                ChildPrice: number
                HasExtraLegRoom: boolean
                IsAisleSeat: boolean;
                IsAvailable: boolean;
                IsExitRow: boolean;
                IsMiddleSeat: boolean;
                IsWindowSeat: boolean;
                Number: string
                RestrictionTextId: number
            }[];
        };
    }

    class SeatPlanUnit {

        flightSeatPlan: FlightSeatPlan;
        minCostPerPerson: number = 0;
        totalPrice : number = 0;
        showPlan : boolean;
        selectSeats: Function;
        getSelectedSeats: Function;

        constructor() {
        }

        selectSeatsParent(seats, seatsPostAdd): void {
            this.selectSeats({seats, seatsPostAdd});
        }

        closePlan(): void {
            this.showPlan = false;
        }

        resetSeats(): void {
            for (const p of this.flightSeatPlan.Passengers) {
                for (const s of p.Seats) {
                    s.Number = null;
                    s.Price = 0;
                }
            }
            this.totalPrice = 0;
        }
    }

    angular
        .module('core')
        .component('seatPlanUnit', {
                bindings: {
                    flightSeatPlan: '=',
                    selectSeats: '&',
                    getSelectedSeats: '&',
                    totalPrice: '=?'
                },
                controller: SeatPlanUnit,
                controllerAs: 'sp',
                templateUrl: 'partials/holidays/seatplanunit'
            }
        );
}
